import style from './Home.module.css'
import { Header } from '../../Components/Header/Header'
import NavBar from '../../Components/NavBar/NavBar'
import { useState } from 'react'
import { Outlet } from 'react-router-dom'

export function Home(){
    const [isOpen, setIsOpen] = useState(false)

    return <div className={`${style.home} ${isOpen ? style.active : ''}`}>
        <NavBar setIsOpen={setIsOpen} isOpen={isOpen}/>
        <Header />
        <Outlet />
    </div>
}